<script setup lang="ts">
import { ref } from 'vue'
import { SpButton } from '@tithely/sproutkit-vue'
import BaseModal from '@/components/base/BaseModal.vue'
import BaseModalHeader from '@/components/base/BaseModalHeader.vue'

withDefaults(
    defineProps<{
        cancelButton?: string
        confirmButton?: string
        confirmText: string
        danger?: boolean
        title?: string
        stack?: boolean
    }>(),
    {
        cancelButton: `Cancel`,
        confirmButton: `Confirm`,
        danger: false,
        title: `Confirm`,
        stack: false
    }
)

const emit = defineEmits<{
    confirm: [void]
}>()

const modal = ref<InstanceType<typeof BaseModal>>()

const open = () => {
    modal.value?.open()
}

const close = () => {
    modal.value?.close()
}

const confirmFn = () => {
    emit(`confirm`)

    close()
}

defineExpose({
    open,
    close
})
</script>

<template>
    <BaseModal
        ref="modal"
        class="flex flex-col gap-4 p-4">
        <BaseModalHeader @close="close">
            <h2 class="text-2xl font-medium">{{ title }}</h2>
        </BaseModalHeader>

        <p class="whitespace-pre-line text-base">{{ confirmText }}</p>

        <footer :class="stack ? 'flex flex-col-reverse gap-2' : 'flex items-center justify-end gap-4'">
            <SpButton
                intent="secondary"
                variant="subtle"
                :class="stack ? 'w-full' : ''"
                @click="close">
                {{ cancelButton }}
            </SpButton>

            <SpButton
                :intent="danger ? `danger` : `primary`"
                :class="stack ? 'w-full' : ''"
                @click="confirmFn">
                {{ confirmButton }}
            </SpButton>
        </footer>
    </BaseModal>
</template>
